<template>
    <div class="transparent-field transparent-select-field">
        <select-field
            :label="label"
            :formData="formData"
            :options="options"
            valuePath="value"
            @change="changed($event)"
        ></select-field>
    </div>
</template>

<script>
    import SelectField from 'components/form-fields/SelectField'

    export default {
        components: { SelectField },
        props: {
            value: { type: String, default: null },
            label: { type: String, default: null },
            options: { type: Array, required: true },
        },
        data() {
            return {
                selectedValue: null,
                formData: {
                    value: this.value,
                },
            }
        },
        methods: {
            changed(e) {
                this.formData.value = e.value
                this.$emit('input', e.value)
            },
        },
    }
</script>

<style scoped lang="scss"></style>
